import GenericCircuitBenefitAdditionModal, {
  CircuitBenefitAdditionModalProps,
} from './GenericCircuitBenefitAdditionModal';

const AddAccommodationBenefitModal = (
  props: CircuitBenefitAdditionModalProps,
) => <GenericCircuitBenefitAdditionModal {...props} modalType="Hébergements" />;

export default AddAccommodationBenefitModal;
